<template lang="pug">
.wrapper-input-multiple-files
  InputFile(
    :label="label"
    @atualizarMultiplosArquivos="atualizarMultiplosArquivos"
    @editarArquivos="abrirModalDeEditarArquivos"
    :accept="accept"
    :error="error"
    multiple
    onlyButtonOpenNewFile
    ref="inputFile"
  )

  PModal(name="modalDeEditarArquivos" height="600px" width="600px" @closed="reseta")
    .wrapper-modal-de-editar-arquivos
      .title
        span {{ totalDeArquivos  }} arquivo(s) anexados
      .lista-de-documentos

        //- arquivos já adicionados
        .linha(v-for="indiceDoArquivoJaSalvo in arquivosJaSalvos")
          .nome-do-arquivo(:title="value[indiceDoArquivoJaSalvo].name") {{ value[indiceDoArquivoJaSalvo].name }}
          .fundo-arredondado
            .icon-ptt-icons-excluir.fs-19.color-danger.to-click(
              title="remover"
              @click="removeArquivo(indiceDoArquivoJaSalvo)"
            )

        //- arquivos ainda para serem adicionados
        .linha(v-for="(arquivo, index) in novosArquivos")
          .nome-do-arquivo.color-success(:title="arquivo.name") {{ arquivo.name }}
          .fundo-arredondado
            .icon-ptt-icons-excluir.fs-19.color-danger.to-click(
              title="remover"
              @click="removeNovoArquivo(index)"
            )
      .botoes
        .aviso(v-if="haAlteracoesNaoSalvas") há alterações não confirmadas
        PButton(color="info" size="md" @click="adicionarDocumento") adicionar mais arquivos
        PButton(color="success" size="md" @click="salvar") confirmar

        input(type="file" :accept="accept" @change="trataNovosArquivos" ref="adicionarDocumentoInput" multiple)
</template>

<script>
import InputFile from 'src/common/inputs/InputFile.vue'

export default {
  name: 'InputMultipleFiles',
  props: {
    value: {type: Array, required: true},
    label: {type: String, required: true},
    accept: {type: String, default: ''},
    error: {type: String, default: ''}
  },
  data () {
    return {
      novosArquivos: [],
      indicesDeArquivosParaRemover: []
    }
  },
  computed: {
    arquivosJaSalvos () {
      return this.value
        .map((_, indiceReal) => indiceReal)
        .filter(indiceReal => !this.indicesDeArquivosParaRemover.includes(indiceReal))
    },
    totalDeArquivos () {
      return (this.value.length + this.novosArquivos.length) - this.indicesDeArquivosParaRemover.length
    },
    haAlteracoesNaoSalvas () {
      return this.novosArquivos.length > 0 || this.indicesDeArquivosParaRemover.length > 0
    }
  },
  methods: {
    atualizarMultiplosArquivos (listaDeArquivos) {
      this.$emit('input', Array.from(listaDeArquivos))
    },
    abrirModalDeEditarArquivos () {
      this.$modal.show('modalDeEditarArquivos')
    },
    adicionarDocumento () {
      this.$refs.adicionarDocumentoInput.click()
    },
    async salvar () {
      let itensJaSalvos = this.value
      const novosArquivos = this.novosArquivos

      if (this.indicesDeArquivosParaRemover.length > 0) {
        const confirmouRemocao = await this.$modalDeConfirmacao({
          text: 'Voce removeu arquivos, tem certeza que deseja confirmar essa mudança?'
        })

        if (!confirmouRemocao) return
        itensJaSalvos = this.value.filter((_, i) => !this.indicesDeArquivosParaRemover.includes(i))
      }

      const novoEstado = [...itensJaSalvos, ...novosArquivos]
      this.$emit('input', novoEstado)
      this.$refs['inputFile'].atualizaArquivos(novoEstado)

      this.reseta()
      this.$modal.hide('modalDeEditarArquivos')
    },
    trataNovosArquivos (e) {
      const arrayDeNovosArquivos = Array.from(e.target.files)
      this.novosArquivos.push(...arrayDeNovosArquivos)
    },
    reseta () {
      this.novosArquivos = []
      this.indicesDeArquivosParaRemover = []
    },
    removeArquivo (index) {
      if (this.indicesDeArquivosParaRemover.includes(index)) return
      this.indicesDeArquivosParaRemover.push(index)
    },
    removeNovoArquivo (index) {
      this.novosArquivos = this.novosArquivos.filter((_, i) => index !== i)
    }
  },
  components: {InputFile}
}
</script>

<style lang="scss" scoped>
.wrapper-input-multiple-files {
  input[type="file"] {
    width: 19%;
    display: none;
  }

  .wrapper-modal-de-editar-arquivos {
    display: grid;
    grid-template-rows: 50px 450px 50px;
    justify-items: center;

    .title {
      font-size: 25px;
      font-weight: bold;
      align-self: center;
      color: var(--color-info)
    }
    .lista-de-documentos {
      overflow-y: scroll;
      border: 1px solid lightgray;
      width: 100%;
      box-sizing: border-box;
      padding: 10px 20px;

      .linha {
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        justify-items: start;
        grid-auto-columns: 492px 30px;
        margin-bottom: 10px;

        .nome-do-arquivo {
          width: 492px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow-x: hidden;
        }

        .fundo-arredondado {
          height: 30px;
          width: 30px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          background-color: #F5F5F5;
        }
      }
    }
    .botoes {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 1px;
      align-self: end;
      justify-self: end;

      .aviso {
        color: var(--color-danger);
        align-self: center;
        margin-right: 10px;
      }
    }
  }
}
</style>
